<div *ngIf="form">
    <div class="d-flex flex-column gap-4">
        <div class="row row-gap-2">
            <div class="col-3 text-end">
                <div class="d-flex h-100 justify-content-end align-items-center"><span>语言:&nbsp;</span></div>
            </div>
            <div class="col-9">
                <app-languages-select [formControl]="form.controls.locale" />
            </div>
        </div>

        <div class="row row-gap-2">
            <div class="col-3 text-end">
                <span>区域:&nbsp;</span>
            </div>
            <div class="col-9">
                <app-regions-select [showNone]="false" [formControl]="form.controls.region" />
            </div>
        </div>

        <div class="row row-gap-2">
            <div class="col-3 text-end">
                <span>组织:&nbsp;</span>
            </div>
            <div class="col-9">
                <app-organizations-select [formControl]="form.controls.organizationId" />
            </div>
        </div>

        <div class="row row-gap-2">
            <div class="col-3 text-end">
                <span>特殊要求:&nbsp;</span>
            </div>
            <div class="col-9">
                <app-have-treatment-plan-radios [formControl]="form.controls.hasTreatmentPlan" />
            </div>
        </div>

        <div class="row row-gap-2">
            <div class="col-3 text-end">
                <span>打印服务:&nbsp;</span>
            </div>
            <div class="col-9">
                <app-fabrication-methods-select [formControl]="form.controls.fabricationMethod" />
            </div>
        </div>

        <div class="row row-gap-2">
            <div class="col-3 text-end">
                <span>特定单次:&nbsp;</span>
            </div>
            <div class="col-9">
                <app-order-number-per-treatment-type-select
                    [formControl]="form.controls.isFirstOrSecondOrderOnly"
                />
            </div>
        </div>

        <div class="row row-gap-2">
            <div class="col-3 text-end">
                <span class="">常规消息:&nbsp;</span>
            </div>

            <div class="col-6">
                <textarea
                    [formControl]="form.controls.message"
                    class="w-100"
                    rows="5"
                    pInputTextarea
                    appAutoResize
                ></textarea>
            </div>
        </div>

        <div class="row row-gap-2">
            <div class="col-3 text-end">
                <span>返修消息:&nbsp;</span>
            </div>

            <div class="col-6">
                <textarea
                    [formControl]="form.controls.revisionMessage"
                    class="w-100"
                    rows="5"
                    pInputTextarea
                    appAutoResize
                ></textarea>
            </div>
        </div>
    </div>
</div>
